import styled from '@emotion/styled';

export const ShipmentContainer = styled.div`
  font-size: ${(props) => props.theme.FONTS.FONT_SIZE_SMALLER};
  color: ${(props) => props.theme.COLORS3.BLACK_050};
  display: flex;
  flex-direction: column;
  row-gap: ${(props) => props.theme.SPACING.S4};
`;
